"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowDesign = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const ResponseBase_1 = require("../../../ResponseBase");
const TaskDesign_1 = require("../../task/TaskDesign/TaskDesign");
const task_1 = require("../../task");
class FlowDesign extends ResponseBase_1.ResponseBase {
    toCreateArgs() {
        const { businessId, name, tasks, flowDesignId, version, description } = this;
        return {
            businessId,
            name,
            description,
            tasks: tasks.map((task) => task.toCreateArgs()),
            flowDesignId,
            version,
        };
    }
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesign.prototype, "businessId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], FlowDesign.prototype, "anonymous", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesign.prototype, "flowDesignId", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsNumber)(),
    (0, tslib_1.__metadata)("design:type", Number)
], FlowDesign.prototype, "version", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesign.prototype, "name", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], FlowDesign.prototype, "description", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsBoolean)(),
    (0, tslib_1.__metadata)("design:type", Boolean)
], FlowDesign.prototype, "isSelfService", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({
        taggedUnion: {
            getTag: (t) => t.type,
            handlers: task_1.TaskDesignClasses,
        },
    }),
    (0, class_validator_1.IsInstance)(TaskDesign_1.TaskDesign, { each: true }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, tslib_1.__metadata)("design:type", Array)
], FlowDesign.prototype, "tasks", void 0);
exports.FlowDesign = FlowDesign;
